import request from "@/utils/request";

export async function apiCheckLogin() {
    return request({url: '/account/web-api/passport/checkLogin', method: 'post'});
}

export async function apiGetLoginInfo() {
    return request({url: '/organization/web-api/enterprise/loginInfo', method: 'get'});
}